import React, { useEffect, useState } from "react";
import * as Mui from "@mui/material";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { useFetch } from "services/hooks/useFetch";
import { useSelector } from "react-redux";
import { CustomButton } from "components/CustomComponents/CustomButton";
import { tableContainerSx, tableHeaderSx, themes } from "services/constants";
import { tooltipStyleProps } from "services/constants/Styles";
import {
  punchHeader,
  modeDetails,
  checkInPolicy,
  checkOutPolicy,
} from "../AdministrationHeaders";
import { customAPI } from "services/utils/CustomAPI";
import { Delete, Info, AddCircleOutline } from "@mui/icons-material";
import { showToast } from "services/utils/Status";
import { formKeyText } from "services/constants/Styles";
let count = 0;

export const PunchDetails = ({ setShowPunchDetails, editDetails }) => {
  const { domain, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  const [editErrorHandle, setEditErrorHandle] = useState(false);
  const {
    result: companyDeviceDetails,
    loading,
    setLoad,
  } = useFetch(`${domain}add-device-details/?company_id=${editDetails?.id}`);
  const { result: companyAllDetails } = useFetch(
    `${domain}device-details/?company_id=${editDetails?.id}`
  );
  let check_access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Companies",
    "Company"
  );
  const [timerError, setTimerError] = useState(false);
  const [selectedTime, setSelectedTime] = useState(null);
  const [overAllDeviceDetails, setOverAllDeviceDetails] = useState([]);
  const [overAllDevice, setOverAllDevice] = useState(companyDeviceDetails);
  const [checkInPolicyData, setCheckInPolicyData] = useState("");
  const [checkOutPolicyData, setCheckOutPolicyData] = useState("");
  const [checkInCheckOutError, setCheckInChecOutError] = useState(false);

  useEffect(() => {
    if (companyDeviceDetails?.length !== 0 && !loading) {
      // const maxId = companyDeviceDetails.data.reduce(
      //   (max, item) => (item.id > max ? item.id : max),
      //   0
      // );
      count = 9999 + 1;
      // count = companyDeviceDetails ? companyDeviceDetails?.data?.length + 1 : 0;
      setOverAllDevice(
        companyDeviceDetails?.data.map((d_details) => {
          return {
            ...d_details,
            isdeleted: false,
          };
        })
      );
      setCheckInPolicyData(companyDeviceDetails?.check_in_policy || "");
      setCheckOutPolicyData(companyDeviceDetails?.check_out_policy || "");
      setSelectedTime(
        dayjs()
          .startOf("day")
          .add(companyDeviceDetails?.punch_thershold_time || 0, "minute")
      );
    }
  }, [companyDeviceDetails, loading]);

  useEffect(() => {
    if (companyAllDetails?.length !== 0 && !loading) {
      let deduction = companyAllDetails;
      companyDeviceDetails?.data?.forEach((earn) => {
        deduction = deduction?.filter((data) => {
          return data.device_name !== earn.device_name;
        });
      });
      setOverAllDeviceDetails(deduction);
    }
  }, [
    companyAllDetails,
    companyAllDetails?.length,
    companyDeviceDetails,
    loading,
  ]);

  const updateDeviceName = (rowDetails) => (event, data) => {
    if (data) {
      let details = overAllDevice;
      let updatedTime = details.map((d_details) =>
        rowDetails.id === d_details?.id
          ? {
              ...d_details,
              device_name: data ? data.device_name : null,
              device_id: data ? data.device_id : null,
              location: data ? data.location : null,
            }
          : d_details
      );
      setOverAllDevice(updatedTime);
    }
  };

  const updateMode = (rowData) => (event, data) => {
    if (data) {
      let details = overAllDevice;
      let updatedTime = details.map((d_details) =>
        rowData.id === d_details?.id
          ? {
              ...d_details,
              mode: data?.label,
            }
          : d_details
      );
      setOverAllDevice(updatedTime);
    }
  };

  const AddnewRow = () => {
    const data = {
      id: count + 1,
      device_id: count + 1,
      device_name: "",
      mode: "",
      location: "",
      newlyAdded: true,
      isdeleted: false,
    };
    setOverAllDevice([...overAllDevice, data]);
    count = count + 1;
  };

  const validateFieldValues = () => {
    const findNullValue = overAllDevice.filter(
      (entry) => entry?.device_name === "" || entry?.mode === ""
    );
    if (findNullValue.length <= 0) {
      return true;
    } else {
      return false;
    }
  };

  const updateEditDetails = async () => {
    if (
      validateFieldValues() &&
      checkInPolicyData !== "" &&
      checkOutPolicyData !== "" &&
      selectedTime !== null &&
      selectedTime.minute() !== 0
    ) {
      setCheckInChecOutError(false);
      const deviceDetails_data = overAllDevice.map((device) => {
        if (device.newlyAdded) {
          const { id, ...rest } = device;
          return rest;
        }
        return device;
      });
      const response = await customAPI(`${domain}add-device-details/`, "PUT", {
        company_id: editDetails?.id,
        check_in_policy: checkInPolicyData,
        check_out_policy: checkOutPolicyData,
        devices: deviceDetails_data,
        punch_thershold_time: selectedTime.minute(),
      });
      if (response.ok) {
        setEditErrorHandle(false);
        setLoad(true);
        showToast("success", response?.responseDetails?.message);
        setTimerError(false);
      }
    } else {
      if (selectedTime === null || selectedTime.minute() === 0) {
        setTimerError(true);
      } else {
        setTimerError(false);
        if (checkInPolicyData === "" || checkOutPolicyData === "") {
          setCheckInChecOutError(true);
        } else {
          setEditErrorHandle(true);
        }
      }
    }
  };

  const deleteDeviceDetails = async (deviceDe) => {
    if (deviceDe) {
      let details = overAllDevice;
      if (deviceDe?.newlyAdded) {
        let updatedTime = details.filter((data) => {
          return data?.id !== deviceDe.id;
        });
        setOverAllDevice(updatedTime);
      } else {
        let updatedTime = details.map((d_details) =>
          deviceDe.id === d_details?.id
            ? {
                ...d_details,
                isdeleted: true,
              }
            : d_details
        );
        setOverAllDevice(updatedTime);
        addedInDropDown(deviceDe);
      }
    }
  };

  const addedInDropDown = (deviceDe) => {
    setOverAllDeviceDetails([...overAllDeviceDetails, deviceDe]);
  };

  const handleCheckInDevice = (event, data) => {
    setCheckInPolicyData(data?.label || "");
  };

  const handleCheckOutDevice = (event, data) => {
    setCheckOutPolicyData(data?.label || "");
  };

  // const selectedDeviceNames = overAllDevice
  //   .map((item) => item.device_name)
  //   .filter(Boolean);

  const selectedDeviceNames = overAllDevice
    .filter((item) => !item.isdeleted && item.device_name)
    .map((item) => item.device_name);

  const handleTimeChange = (newValue) => {
    setSelectedTime(newValue);
  };

  return (
    <Mui.Grid
      container
      sx={{
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 10,
      }}
    >
      <Mui.Grid
        container
        sx={{
          padding: 1,
          backgroundColor: themes.primary,
          borderRadius: "10px 10px 0 0",
          border: `2px solid ${themes.sidebarDivider}`,
          borderBottom: "none",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Mui.Typography
          sx={{
            fontSize: 24,
            fontWeight: 800,
            font: "bold",
            textAlign: "center",
          }}
        >
          Attendance Device
        </Mui.Typography>
      </Mui.Grid>
      <Mui.Grid
        container
        sx={{
          paddingTop: -1,
          border: `2px solid ${themes.sidebarDivider}`,
          padding: 2,
          borderRadius: "0 0 10px 10px",
        }}
      >
        <Mui.Grid container sx={{ paddingTop: 2 }}>
          <Mui.Grid xs={6}>
            <Mui.Typography sx={formKeyText}>
              Company&nbsp;
              <Mui.Tooltip
                arrow
                slotProps={tooltipStyleProps}
                title="The punching device setup and the details provided below are specific to this company only"
              >
                <Info />
              </Mui.Tooltip>
            </Mui.Typography>
          </Mui.Grid>
          <Mui.Grid xs={3} sx={{ paddingTop: 1 }}>
            <Mui.Typography>{editDetails?.companyname}</Mui.Typography>
          </Mui.Grid>
        </Mui.Grid>
        <Mui.Grid container sx={{ paddingTop: 2 }}>
          <Mui.Grid xs={6}>
            <Mui.Typography sx={formKeyText}>
              CheckIn Policy&nbsp;
              <Mui.Tooltip
                arrow
                slotProps={tooltipStyleProps}
                title="The punching device setup and the details provided below are specific to this company only"
              >
                <Info />
              </Mui.Tooltip>
            </Mui.Typography>
          </Mui.Grid>
          <Mui.Grid xs={2.4} sx={{ paddingTop: 1 }}>
            <Mui.Typography>
              <CustomAutoComplete
                dataList={checkInPolicy}
                selectedValue={checkInPolicyData}
                updateDataFunction={handleCheckInDevice}
                placeHolder="Select the Device"
              />
              {checkInPolicyData === "" && checkInCheckOutError ? (
                <span style={{ color: themes.txtErrorColor }}>
                  Check in policy is required
                </span>
              ) : null}
            </Mui.Typography>
          </Mui.Grid>
        </Mui.Grid>
        <Mui.Grid container sx={{ paddingTop: 2 }}>
          <Mui.Grid xs={6}>
            <Mui.Typography sx={formKeyText}>
              CheckOut Policy&nbsp;
              <Mui.Tooltip
                arrow
                slotProps={tooltipStyleProps}
                title="The punching device setup and the details provided below are specific to this company only"
              >
                <Info />
              </Mui.Tooltip>
            </Mui.Typography>
          </Mui.Grid>
          <Mui.Grid xs={2.4} sx={{ paddingTop: 1 }}>
            <Mui.Typography>
              <CustomAutoComplete
                dataList={checkOutPolicy}
                selectedValue={checkOutPolicyData}
                updateDataFunction={handleCheckOutDevice}
                placeHolder="Select the Device"
              />
              {checkOutPolicyData === "" && checkInCheckOutError ? (
                <span style={{ color: themes.txtErrorColor }}>
                  Check in policy is required
                </span>
              ) : null}
            </Mui.Typography>
          </Mui.Grid>
        </Mui.Grid>

        <Mui.Grid container sx={{ paddingTop: 1 }}>
          <Mui.Grid xs={6}>
            <Mui.Typography sx={{ ...formKeyText, paddingTop: 3 }}>
              Punch Entry Thershold Time&nbsp;
              <Mui.Tooltip
                arrow
                slotProps={tooltipStyleProps}
                title="The punching device setup and the details provided below are specific to this company only"
              >
                <Info />
              </Mui.Tooltip>
            </Mui.Typography>
          </Mui.Grid>
          <Mui.Grid xs={4} sx={{ paddingTop: 1 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["TimePicker"]}>
                <TimePicker
                  ampm={false}
                  views={["minutes"]}
                  value={selectedTime}
                  onChange={handleTimeChange}
                  viewRenderers={{
                    minutes: renderTimeViewClock,
                  }}
                  slotProps={{
                    textField: {
                      size: "small",
                      sx: { width: "60%" },
                    },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
            {timerError && (
              <Mui.Typography
                variant="body2"
                color="error"
                sx={{
                  fontSize: 13,
                  paddingTop: 0.5,
                }}
              >
                Minutes is required
              </Mui.Typography>
            )}
          </Mui.Grid>
        </Mui.Grid>

        <Mui.Grid
          container
          sx={{ paddingRight: 1, overflow: "hidden", paddingBottom: 10, mt: 1 }}
        >
          <Mui.TableContainer sx={tableContainerSx}>
            <Mui.Table>
              <Mui.TableHead sx={tableHeaderSx}>
                <Mui.TableRow
                  maxWidth="xl"
                  align="left"
                  sx={{
                    "& .MuiTableCell-root": {
                      height: "10px",
                      padding: "3px 15px",
                    },
                  }}
                >
                  {punchHeader?.map?.((value) => (
                    <Mui.TableCell
                      sx={{
                        color: themes.headLine,
                        fontWeight: "bold",
                        fontSize: 17,
                      }}
                    >
                      {value?.name}
                    </Mui.TableCell>
                  ))}
                </Mui.TableRow>
              </Mui.TableHead>
              <Mui.TableBody>
                {overAllDevice?.length === 0 ? (
                  <Mui.TableCell colSpan={12}>
                    <Mui.Alert sx={{ mt: 1 }} severity="info">
                      No data available
                    </Mui.Alert>
                  </Mui.TableCell>
                ) : (
                  overAllDevice?.map((data, index) =>
                    !data?.isdeleted ? (
                      <Mui.TableRow
                        key={data?.device_id}
                        sx={{
                          "& .MuiTableCell-root": {
                            height: "10px",
                            padding: "3px 15px",
                          },
                        }}
                      >
                        <Mui.TableCell>
                          {data?.newlyAdded ? (
                            <>
                              <CustomAutoComplete
                                // dataList={overAllDeviceDetails?.map((obj) => ({
                                //   ...obj,
                                //   label: obj.device_name,
                                // }))}
                                dataList={overAllDeviceDetails
                                  ?.filter((obj) => {
                                    return (
                                      !selectedDeviceNames.includes(
                                        obj.device_name
                                      ) || obj.device_name === data.device_name
                                    );
                                  })
                                  .map((obj) => ({
                                    ...obj,
                                    label: obj.device_name,
                                  }))}
                                selectedValue={data?.device_name}
                                updateDataFunction={updateDeviceName(data)}
                                placeHolder="Select the Device"
                              />
                              {data?.device_name === "" && editErrorHandle ? (
                                <span style={{ color: themes.txtErrorColor }}>
                                  Device name is required
                                </span>
                              ) : null}
                            </>
                          ) : (
                            <Mui.TextField
                              size="small"
                              value={data?.device_name}
                              disabled={true}
                              fullWidth
                            />
                          )}
                        </Mui.TableCell>
                        <Mui.TableCell>
                          <Mui.TextField
                            value={data?.location}
                            size="small"
                            fullWidth
                            disabled
                          />
                        </Mui.TableCell>
                        <Mui.TableCell>
                          <CustomAutoComplete
                            dataList={modeDetails}
                            selectedValue={data?.mode}
                            updateDataFunction={updateMode(data)}
                            placeHolder="Select the mode"
                          />
                          {data?.mode === "" && editErrorHandle ? (
                            <span style={{ color: themes.txtErrorColor }}>
                              Device mode is required
                            </span>
                          ) : null}
                        </Mui.TableCell>
                        <Mui.TableCell>
                          <Mui.IconButton
                            onClick={() => {
                              if (check_access) {
                                deleteDeviceDetails(data);
                              } else {
                                showToast(
                                  "error",
                                  "Access denied: You are not authorized to remove the device"
                                );
                              }
                            }}
                          >
                            <Delete />
                          </Mui.IconButton>
                        </Mui.TableCell>
                      </Mui.TableRow>
                    ) : null
                  )
                )}
              </Mui.TableBody>
              <Mui.TableBody>
                <Mui.TableCell></Mui.TableCell>
                <Mui.TableCell></Mui.TableCell>
                <Mui.TableCell></Mui.TableCell>
                <Mui.TableCell>
                  <Mui.IconButton
                    onClick={() => {
                      AddnewRow();
                    }}
                    disabled={overAllDeviceDetails?.length !== 0 ? false : true}
                  >
                    <AddCircleOutline />
                  </Mui.IconButton>
                </Mui.TableCell>
              </Mui.TableBody>
            </Mui.Table>
          </Mui.TableContainer>
        </Mui.Grid>
        <Mui.Grid
          container
          spacing={1}
          sx={{
            paddingTop: 2,
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            paddingRight: 1,
          }}
        >
          <Mui.Grid item>
            <CustomButton
              actionName="Cancel"
              typeName="button"
              actionFuntion={() => {
                setShowPunchDetails(false);
              }}
            />
          </Mui.Grid>
          <Mui.Grid item>
            <CustomButton
              actionName="Save"
              typeName="button"
              actionFuntion={() => {
                if (check_access) {
                  updateEditDetails(false);
                } else {
                  showToast(
                    "error",
                    "Access denied: You are not authorized to save the device"
                  );
                }
              }}
            />
          </Mui.Grid>
        </Mui.Grid>
      </Mui.Grid>
    </Mui.Grid>
  );
};
